<template>
  <div>
    <!--RESPONSABLES POR COBRAR-->
    <v-dialog v-model="dialogResp" v-if="dialogResp" width="780" persistent>
      <s-agricultural-farm-responsible-collecting
        :FltID="FltID"
        :PrdID="selectedPrdID"
        @hideModal="dialogResp = false"
        @close="dialogResp = false"
      />
    </v-dialog>

    <v-dialog
      v-if="openDialogView"
      v-model="openDialogView"
      persistent
      style="display: contents"
      width="70%"
    >
      <s-certification-lot :FltID="FltID" @close="openDialogView = false" />
    </v-dialog>

    <s-crud
      title="Lotes"
      :config="configCrud"
      @save="save($event)"
      @EditEvent="edit($event)"
      :edit="this.isAdmin"
      :add="this.isAdmin"
      :remove="this.isAdmin"
      :filter="filter"
      @rowSelected="rowSelectedFarmsLot($event)"
      ref="crud2"
      search-input
    >
      <template slot-scope="props">
        <v-container class="pb-3">
          <v-row justify="center">
            <v-col cols="12" class="s-col-form" sm="6" md="3">
              <s-text v-model="props.item.FltCodSenasa" label="Cod. Senasa" />
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="3" lg="2">
              <s-text v-model="props.item.FltCode" label="Codigo" />
            </v-col>
            <v-col cols="12" class="s-col-form" md="3">
              <s-text v-model="props.item.FltName" label="Nombre" autofocus />
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="3" lg="2">
              <s-text v-model="props.item.FltDocSenasa" label="Doc. Productor Senasa" />
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="3" lg="2">
              <s-select-definition
                v-model="props.item.FltLevel"
                :def="1183"
                label="Nivel"
              ></s-select-definition>
            </v-col>
            <v-col
              v-if="props.item.FltLevel == 2"
              cols="12"
              class="s-col-form"
              md="9"
              lg="5"
            >
              <s-select-lot
                :levelID="props.item.FltLevel"
                :fundoID="agriculturalFarmID"
                :indicadorLot="3"
                full
                clearable
                no-default
                return-object
                v-model="ObjLot"
                label="Nombre del Lote"
                @input="inputLot($event, props.item)"
                v-if="props.item.FltLevel == 2"
              >
              </s-select-lot>
            </v-col>
            <!-- PRODUCTOR -->
            <v-col cols="12" class="s-col-form" md="6" lg="3">
              <s-select-producer
                :text="props.item.PrdCardName"
                v-model="props.item.PrdID"
                label="Productor Asociado"
              />
            </v-col>
            <!-- CODIGO ORGANICO -->
            <v-col cols="12" class="s-col-form" sm="6" md="3" lg="2">
              <!-- TypeCondition -->
              <s-select-definition
                v-model="props.item.TypeCrop"               
                :def="1172"
                label="Tipo de Cultivo"
              />
            </v-col>
            <v-col
              cols="12"
              class="s-col-form"
              sm="6"
              md="3"
              lg="2"
              v-if="props.item.TypeCrop == 1"
            >
              <s-text
                label="Cod. Orgánico"
               
                :typecropID="props.item.TypeCrop"
                v-model="props.item.FltCodeOrganic"
              >
              </s-text>
            </v-col>
            <v-col cols="12" class="s-col-form d-flex align-end" sm="6" md="3">
              <s-text
                v-model="dataPlants.FltPlants"
                label="Total Plantas"
                number
                readonly
              />
              <v-btn
                class="ml-2"
                fab
                v-if="props.item.FltID"
                x-small
                color="success"
                @click="openDialogPlants(props.item.FltID)"
                ><v-icon>mdi-eye</v-icon></v-btn
              >
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="3">
              <s-text
                v-model="dataPlants.FltSowingYear"
                label="Primer Año de Sembrado"
                placeholder="AAAA"
                mask="####"
                readonly
              />
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="3">
              <s-select-definition
                
                v-model="props.item.TypeCultive"
                :def="1173"
                id="DedValue"
                label="Cultivo"
              ></s-select-definition>
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="2">
              <s-select-variety                
                :cultiveID="props.item.TypeCultive"
                v-model="props.item.VrtID"
                label="Variedad"
              >
              </s-select-variety>
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="2">
              <s-text v-model="props.item.FltNLots" label="Num. Lote" number />
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="2">
              <s-text v-model="props.item.FltFlow" label="Caudal" decimal />
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="2">
              <s-text
                v-model="props.item.FltHectares"
                label="Hectareas Certificadas"
                decimal
              />
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="2">
              <s-text
                v-model="props.item.FltHectaresFull"
                label="Hectareas Totales (m)"
                decimal
              />
            </v-col>
            <v-col cols="12" class="s-col-form" sm="3" md="2">
              <s-text v-model="props.item.FltVolume" label="Volumen (Tn)" decimal />
            </v-col>
            <v-col cols="12" class="s-col-form" sm="3" md="2">
              <s-text v-model="props.item.FltCylinder" label="Cilindros" decimal />
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="2">
              <s-select-definition
                v-model="props.item.FltStatus"
                :def="1242"
                label="Estado"
              >
              </s-select-definition>
            </v-col>
            <v-col cols="12" class="s-col-form" sm="5" md="3">
              <s-select-definition
                v-model="props.item.FltProbabilityOfSale"
                :def="1585"
                label="Probabilidad de Venta"
              >
              </s-select-definition>
            </v-col>
            <v-col cols="12" class="s-col-form" sm="7" md="3">
              <s-select-definition
                v-model="props.item.FltReasonForNoSale"
                :def="1586"
                label="Motivo de No Venta"
              >
              </s-select-definition>
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="2">
              <s-text
                v-model="props.item.FltJabasPotential"
                label="Potencial de Jabas"
                decimal
                :min="0"
              ></s-text>
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="2">
              <s-text
                v-model="props.item.FltDistance"
                label="Distancia"
                decimal
                :min="0"
                suffix="Km"
              ></s-text>
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="2">
              <s-text v-model="props.item.FltLatituded" label="Latitud"></s-text>
            </v-col>
            <v-col cols="12" class="s-col-form" sm="6" md="2">
              <s-text v-model="props.item.FltLength" label="Longitud"></s-text>
            </v-col>
            <v-col cols="12" class="s-col-form" lg="10">
              <s-text v-model="props.item.FltObservation" label="Observación" />
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:ViewCert="{ row }">
        <v-btn x-small color="info" block outlined @click="clickView(row)">
          <v-icon style="font-size: 16px !important">fas fa-eye</v-icon>
        </v-btn>
      </template>
      <template v-slot:ViewMap="{ row }">
        <v-btn x-small color="info" block outlined @click="openLotMap(row)">
          <v-icon style="font-size: 16px !important">mdi mdi-google-maps</v-icon>
        </v-btn>
      </template>

      <template v-slot:ViewPhone="{ row }">
        <v-btn x-small color="success" block @click="clickViewPhone(row)">
          <v-icon style="font-size: 16px !important">mdi-card-account-phone</v-icon>
        </v-btn>
      </template>

      <template v-slot:FltDistance="{ row }">
        {{ row.FltDistance ? row.FltDistance + " Km" : "" }}
      </template>

      <template v-slot:TypeCrop="{ row }">
        <v-simple-checkbox
          hide-details=""
          disabled=""
          style="margin: 0px; padding: 0px"
          :value="row.TypeCrop == 1 ? true : false"
        >
        </v-simple-checkbox>
      </template>
      <template v-slot:Cultive="{ row }">
        <v-simple-checkbox
          hide-details=""
          disabled=""
          style="margin: 0px; padding: 0px"
          :value="row.Cultive == 1 ? true : false"
        >
        </v-simple-checkbox>
      </template>
      <template v-slot:FltStatus="{ row }">
        <v-chip
          style="margin: 0px"
          x-small
          :color="row.FltStatus == 1 ? 'success' : 'error'"
        >
          {{ row.FltStatus == 1 ? "Activo" : "Inactivo" }}
        </v-chip>
      </template>
      <template v-slot:FltLevel="{ row }">
        <v-chip
          style="margin: 0px"
          x-small
          :color="
            row.FltLevel == 1 ? 'success' : row.FltLevel == 2 ? 'warning' : 'default'
          "
        >
          {{ row.FltLevel == 1 ? "Lote" : row.FltLevel == 2 ? "SubLote" : "Lote Padre" }}
        </v-chip>
      </template>
      <template v-slot:RespCollecting="{ row }">
        <v-btn
          icon
          color="light-blue darken-4"
          small
          @click="
            dialogResp = true;
            FltID = row.FltID;
            selectedPrdID = row.PrdID;
          "
        >
          <v-icon>mdi-account-circle</v-icon>
        </v-btn>
      </template>
    </s-crud>

    <!-- Modal seleccionar ubicación de Lote -->
    <v-dialog v-model="showLotMapModal" fullscreen persistent>
      <v-card>
        <v-toolbar color="primary" dark dense>
          <v-toolbar-title>Seleccionar ubicación del Lote</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="showLotMapModal = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <div class="map-container">
            <l-map
              ref="lotMap"
              :zoom="lotMapZoom"
              :center="lotMapCenter"
              @ready="onLotMapReady"
              @click="onLotMapClick"
            >
              <l-tile-layer :url="tileUrl" :attribution="tileAttribution" />
              <l-marker
                v-if="currentLot && currentLot.FltLatituded && currentLot.FltLength"
                :lat-lng="[
                  parseFloat(currentLot.FltLatituded),
                  parseFloat(currentLot.FltLength),
                ]"
              />
            </l-map>
          </div>
          <div class="d-flex mt-2" style="gap: 8px; align-items: center; flex-wrap: wrap">
            <v-text-field
              dense
              outlined
              hide-details
              label="Latitud"
              :value="currentLot?.FltLatituded"
              readonly
              style="max-width: 200px"
            />
            <v-text-field
              dense
              outlined
              hide-details
              label="Longitud"
              :value="currentLot?.FltLength"
              readonly
              style="max-width: 200px"
            />
            <v-text-field
              dense
              outlined
              hide-details
              label="Coordenadas (DMS)"
              v-model="coordInputLot"
              style="max-width: 320px"
            />
            <v-btn small outlined color="primary" class="ml-2" @click="goToCoordsLot">
              <v-icon left small>mdi-crosshairs</v-icon> Ir
            </v-btn>
            <v-spacer />
            <v-btn
              small
              outlined
              color="accent"
              @click="useMyLocationLot"
              :loading="locating"
            >
              <v-icon left small>mdi-crosshairs-gps</v-icon> Mi ubicación</v-btn
            >
            <v-btn
              v-if="!hasLotGeom"
              small
              outlined
              color="indigo"
              class="ml-2"
              @click="startLotDraw"
              ><v-icon left small>mdi-vector-polygon</v-icon> Dibujar polígono</v-btn
            >
            <v-btn v-else small outlined color="orange" class="ml-2" @click="startLotEdit"
              ><v-icon left small>mdi-square-edit-outline</v-icon> Editar polígono</v-btn
            >
            <v-btn small outlined color="primary" class="ml-2" @click="centerToFarm"
              ><v-icon left small>mdi-home-group</v-icon> Ir a Fundo</v-btn
            >
            <v-btn
              small
              color="green"
              class="ml-2"
              :disabled="!lotGeom || (isSublote && !lotGeomValid)"
              @click="saveLotGeometry"
              ><v-icon left small>mdi-content-save</v-icon> Guardar polígono</v-btn
            >
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="showLotMapModal = false">Cancelar</v-btn>
          <v-btn color="primary" @click="confirmLotLocation">Usar coordenadas</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="openDialogViewPhone" persistent max-width="900px">
      <v-container>
        <v-card>
          <s-crud
            title="Contactos"
            :filter="{ FltID: this.FltID }"
            close
            @close="openDialogViewPhone = false"
            search-input
            :config="configPhone"
            @save="savePhone($event)"
            add
            edit
            remove
          >
            <template slot-scope="props">
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <s-select-definition
                      :def="1561"
                      v-model="props.item.FlpType"
                      label="Tipo"
                      clearable
                      :add="$fun.isAdmin()"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <s-text v-model="props.item.FlpName" label="Nombre" clearable>
                    </s-text>
                  </v-col>
                  <v-col cols="12" md="6">
                    <s-text v-model="props.item.FlpDoc" label="DNI" clearable> </s-text>
                  </v-col>
                  <v-col cols="12" md="6">
                    <s-text v-model="props.item.FlpPhone" label="Telefono" clearable>
                    </s-text>
                  </v-col>
                </v-row>
              </v-container>
            </template>
          </s-crud>
        </v-card>
      </v-container>
    </v-dialog>
    <AlertSunshine :dialog="loading" />

    <v-card v-if="hasDestForMap">
      <v-container>
        <MapsSunExpert
          :destinationLat="mapLat"
          :destinationLng="mapLng"
          :destinationDMS="FltLatitudedLenght.length ? FltLatitudedLenght : null"
        />
      </v-container>
    </v-card>

    <v-dialog v-model="openDialogViewPlants" persistent max-width="900px">
      <v-container>
        <v-card>
          <s-crud
            title="Detalle de Plantas"
            :filter="{ FltID: this.FltID }"
            close
            @close="openDialogViewPlants = false"
            search-input
            :config="configPlants"
            @save="savePlants($event)"
            add
            edit
            remove
            @getDataRefresh="getDataRefreshPlants($event)"
          >
            <template slot-scope="props">
              <v-container>
                <v-row>
                  <v-col cols="12" md="6">
                    <s-text v-model="props.item.FltPlants" label="Plantas" clearable>
                    </s-text>
                  </v-col>
                  <v-col cols="12" md="6">
                    <s-text
                      v-model="props.item.FltSowingYear"
                      label="Año de Siembra"
                      clearable
                    >
                    </s-text>
                  </v-col>
                </v-row>
              </v-container>
            </template>
          </s-crud>
        </v-card>
      </v-container>
    </v-dialog>
    <AlertSunshine :dialog="loading" />
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import _sFarmLot from "@/services/Technicalassistance/FarmLotService.js";
import _sAgriculturalFarms from "@/services/Technicalassistance/AgriculturalFarmsService";
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet-draw";
import SSelectLot from "../../../components/HarvestSchedule/SSelectLot";
import SSelectVariety from "../../../components/HarvestSchedule/SSelectVariety.vue";
import SSelectProducer from "../../../components/HarvestSchedule/SSelectProducer.vue";
import SAgriculturalFarmResponsibleCollecting from "../../../components/TecnicalAssistence/ProducersFarms/sAgriculturalFarmResponsibleCollecting.vue";
import SCertificationLot from "@/components/TecnicalAssistence/sCertificationLot.vue";
import FarmLotPhoneService from "../../../services/Technicalassistance/FarmLotPhoneService";
import FarmLotPlantsService from "../../../services/Technicalassistance/FarmLotPlantsService";
import MapsSunExpert from "../../../components/Utils/MapsSunExpert.vue";
import AlertSunshine from "@/components/Utils/AlertSunshine.vue";

// Fix iconos Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    SSelectVariety,
    SSelectLot,
    SSelectProducer,
    SAgriculturalFarmResponsibleCollecting,
    SCertificationLot,
    MapsSunExpert,
    AlertSunshine,
  },
  props: {
    isAdmin: { type: Boolean, default: false },
    agriculturalFarmID: { type: Number, default: 0 },
    parentID: { type: Number, default: 0 },
  },

  data: () => ({
    itemLot: {},
    // Mapa para seleccionar coordenadas del Lote
    showLotMapModal: false,
    plant: { lat: -4.9005, lng: -80.3314 },
    lotPointInfoMarker: null,
    // Punto de vista previa (para coordenadas pegadas) independiente del punto oficial
    previewPointLayer: null,
    previewPoint: null, // { lat, lon }
    lotInfoMap: null,
    currentLot: null,
    lotGeom: null,
    lotDrawControl: null,
    lotGeomLayer: null,
    // Solo se podrá editar el PRIMER polígono del lote
    firstLotLayer: null,
    farmOutlineLayer: null,
    parentLotOutlineLayer: null,
    siblingsLayer: null,
    otherLotsLayer: null,
    lotMapCenter: [-5.19449, -80.63282],
    lotMapZoom: 15,
    tileUrl: "https://tiles.stadiamaps.com/tiles/alidade_satellite/{z}/{x}/{y}{r}.jpg",
    tileAttribution: "© Stadia Maps | © OpenStreetMap",
    locating: false,
    coordInputLot: "",
    FltID: 0,
    selectedPrdID: 0,
    loading: false,
    openingLotMap: false,
    dialogResp: false,
    filter: { FagID: 0 },
    ObjVariedad: {
      variedadObj: null,
    },
    ObjLot: null,
    openDialogView: false,
    openDialogViewPhone: false,
    openDialogViewPlants: false,
    dataPlants: {
      FltPlants: 0,
      FltSowingYear: 0,
    },
    configPhone: {
      model: {
        FlpID: "ID",
      },
      service: FarmLotPhoneService,
      headers: [
        { text: "ID", value: "FlpID", width: 50 },
        { text: "Tipo", value: "FlpTypeName" },
        { text: "Nombre", value: "FlpName" },
        { text: "DNI", value: "FlpDoc" },
        { text: "Telefono", value: "FlpPhone" },
      ],
    },
    configPlants: {
      model: {
        FlpID: "ID",
      },
      service: FarmLotPlantsService,
      headers: [
        { text: "ID", value: "FlpID", width: 50 },
        { text: "Plantas", value: "FltPlants" },
        { text: "Año de Siembra", value: "FltSowingYear" },
      ],
    },
    FltLatitudedLenght: [],
    mapLat: null,
    mapLng: null,
    lotGeomValid: true,
  }),

  computed: {
    hasLotGeom() {
      // Consideramos que el lote tiene geometría solo si existe una capa que coincide con su FltID
      return !!this.firstLotLayer;
    },
    configCrud() {
      return {
        model: {
          ViewMap: "",
          FltID: "ID",
          FagID: "int",
          FltName: "string",
          /* CodSenasa: "string", */
          TypeCropText: "int",
          FltCodeOrganic: "string",
          TypeVarietyText: "int",
          CultiveText: "int",
          FltVolume: "int",
          TypeCultive: "int",
          VrtID: "int",
          FltObservation: "string",
          FltLevel: "int",
          FkFltIDText: "int",
          FltStatus: "int",
          RespCollecting: "",
          ViewCert: "",
          ViewPhone: "",
        },
        service: _sFarmLot,
        headers: this.isAdmin
          ? [
              { text: "Maps", value: "ViewMap", width: 70 },
              { text: "Contactos", value: "ViewPhone", width: 70 },
              { text: "View", value: "ViewCert", width: 70 },
              { text: "ID", value: "FltID", sortable: false },
              { text: "Estado", value: "FltStatus", sortable: false },
              { text: "Lote", value: "FltName", width: 170 },
              { text: "Cultivo", value: "CultiveText" },
              { text: "Variedad", value: "VrtIDText" },
              {
                text: "Tipo de Cultivo",
                value: "TypeCropText",
                width: 100,
              },
              {
                text: "Productor",
                value: "PrdCardName",
                width: 200,
                align: "center",
              },
              {
                text: "Responsable Cobrador",
                value: "PrdText",
                width: 200,
                align: "center",
              },
              {
                text: "Cobro",
                value: "RespCollecting",
                width: 50,
                align: "center",
              },

              { text: "Nivel", value: "FltLevel", width: 70 },
              {
                text: "Lote Padre",
                value: "FkFltIDText",
                width: 200,
              },
              {
                text: "Cod. Orgánico",
                value: "FltCodeOrganic",
                width: 100,
              },
              { text: "Total Plantas", value: "FltPlants" },
              {
                text: "Primer Año de Siembra",
                value: "FltSowingYear",
                width: 120,
              },
              { text: "Caudal", value: "FltFlow", width: 100 },
              { text: "Num. Lotes", value: "FltNLots", width: 80 },
              { text: "Doc. Productor Senasa", value: "FltDocSenasa", width: 150 },
              { text: "Probabilidad de venta", value: "FltProbabilityOfSaleText" },
              { text: "Motivo de no venta", value: "FltReasonForNoSaleText" },
              { text: "Potencial de Jabas", value: "FltJabasPotential" },
              { text: "Distancia", value: "FltDistance" },
              {
                text: "Observación",
                value: "FltObservation",
                sortable: false,
                width: 200,
              },
            ]
          : [
              { text: "Maps", value: "ViewMap", width: 70 },
              { text: "View", value: "ViewCert", width: 70 },
              { text: "ID", value: "FltID", sortable: false },
              {
                text: "Lote",
                value: "FltName",
                sortable: false,
                width: 200,
              },
              {
                text: "Tipo de Cultivo",
                value: "TypeCropText",
                sortable: false,
              },
              {
                text: "Cultivo",
                value: "CultiveText",
                sortable: false,
              },
              /* { text: "Tipo Variedad", value: "TypeVariety", sortable: false }, */
              { text: "Variedad", value: "VrtIDText" },
              {
                text: "Hectareas",
                value: "FltHectares",
                sortable: false,
              },
              {
                text: "Volumen",
                value: "FltVolume",
                sortable: false,
              },
              {
                text: "Lote",
                value: "FkFltIDText",
                sortable: false,
                width: 200,
              },
              { text: "Total Plantas", value: "FltPlants", sortable: false },
              {
                text: "Primer Año de Siembra",
                value: "FltSowingYear",
                sortable: false,
              },
              { text: "Caudal", value: "FltFlow", sortable: false },
              {
                text: "Num. Lotes",
                value: "FltNLots",
                sortable: false,
              },
              { text: "Probabilidad de venta", value: "FltProbabilityOfSaleText" },
              { text: "Motivo de no venta", value: "FltReasonForNoSaleText" },
              { text: "Potencial de Jabas", value: "FltJabasPotential" },
              { text: "Distancia", value: "FltDistance" },
              {
                text: "Observación",
                value: "FltObservation",
                sortable: false,
                width: 200,
              },
              { text: "Nivel", value: "DedValue", sortable: false },
              { text: "Estado", value: "FltStatus", sortable: false },
            ],
      };
    },
    hasDestForMap() {
      return (
        (this.mapLat != null && this.mapLng != null) ||
        (this.FltLatitudedLenght && this.FltLatitudedLenght.length > 0)
      );
    },
    isSublote() {
      return (
        (this.currentLot && this.currentLot.FltLevel == 2) ||
        (this.itemLot && this.itemLot.FltLevel == 2)
      );
    },
  },
  methods: {
    // --- Helpers: punto en polígono (ray casting) ---
    _pointInRing(lat, lng, ring) {
      try {
        let inside = false;
        for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
          const xi = ring[i].lat,
            yi = ring[i].lng;
          const xj = ring[j].lat,
            yj = ring[j].lng;
          const intersect =
            yi > lng !== yj > lng &&
            lat < ((xj - xi) * (lng - yi)) / (yj - yi + 0.0) + xi;
          if (intersect) inside = !inside;
        }
        return inside;
      } catch (_) {
        return false;
      }
    },
    _pointInLayer(lat, lng, layer) {
      try {
        const latlngs = layer.getLatLngs && layer.getLatLngs();
        if (!latlngs || latlngs.length === 0) return false;
        const normalize = (arr) => {
          if (Array.isArray(arr[0]) && Array.isArray(arr[0][0])) return arr; // MultiPolygon
          return Array.isArray(arr[0]) ? [arr] : [[arr]]; // Polygon o anillo
        };
        const polys = normalize(latlngs);
        for (const poly of polys) {
          const outer = poly[0] || [];
          if (outer.length === 0) continue;
          const insideOuter = this._pointInRing(lat, lng, outer);
          if (!insideOuter) continue;
          let inHole = false;
          for (let h = 1; h < poly.length; h++) {
            if (this._pointInRing(lat, lng, poly[h] || [])) {
              inHole = true;
              break;
            }
          }
          if (!inHole) return true;
        }
        return false;
      } catch (_) {
        return false;
      }
    },
    _isPointInsideLot(lat, lng) {
      try {
        const target = this.firstLotLayer;
        if (!target) return true; // si no hay polígono propio del lote, permitir
        return this._pointInLayer(lat, lng, target);
      } catch (_) {
        return true;
      }
    },
    _setLotPointIfValid(lat, lng) {
      if (this._isPointInsideLot(lat, lng)) {
        if (this.currentLot) {
          this.currentLot.FltLatituded = Number(lat).toFixed(6);
          this.currentLot.FltLength = Number(lng).toFixed(6);
        }
        return true;
      }
      this.$fun &&
        this.$fun.toast &&
        this.$fun.toast("El punto debe estar dentro del polígono del lote", "warning");
      return false;
    },
    // --- Vista previa en el mapa (siempre muestra, aunque esté fuera del polígono) ---
    _updatePreviewPoint(lat, lon, opts = {}) {
      try {
        const map = this.$refs.lotMap && this.$refs.lotMap.mapObject;
        if (!map || isNaN(lat) || isNaN(lon)) return;
        // eliminar anterior
        if (this.previewPointLayer) {
          try {
            map.removeLayer(this.previewPointLayer);
          } catch (_) {}
          this.previewPointLayer = null;
        }
        // crear nuevo circleMarker naranja
        const color = opts.color || "#ff9800";
        const text = opts.text || "Vista previa";
        const cm = L.circleMarker([lat, lon], {
          radius: 7,
          color,
          weight: 2,
          fillColor: color,
          fillOpacity: 0.9,
          opacity: 0.9,
        }).addTo(map);
        try {
          cm.bindTooltip(text, { permanent: false, direction: "top", offset: [0, -8] });
        } catch (_) {}
        this.previewPointLayer = cm;
        this.previewPoint = { lat, lon };
      } catch (_) {}
    },
    _clearPreviewPoint() {
      try {
        const map = this.$refs.lotMap && this.$refs.lotMap.mapObject;
        if (map && this.previewPointLayer) {
          try {
            map.removeLayer(this.previewPointLayer);
          } catch (_) {}
        }
        this.previewPointLayer = null;
        this.previewPoint = null;
      } catch (_) {
        this.previewPointLayer = null;
        this.previewPoint = null;
      }
    },
    // --- Parser de coordenadas (DMS/decimal) ---
    _parseDMS(val) {
      try {
        if (val == null) return NaN;
        const s = String(val).trim();
        if (s.length === 0) return NaN;
        const upper = s.toUpperCase();
        const dir = (upper.match(/[NSEW]/) || [null])[0];
        const m = upper.match(
          /(-?\d+(?:\.\d+)?)\s*(?:[°º])?\s*(\d+(?:\.\d+)?)?'?\s*(\d+(?:\.\d+)?)?"?/
        );
        let deg = 0,
          min = 0,
          sec = 0;
        if (m) {
          deg = parseFloat(m[1] || 0);
          min = parseFloat(m[2] || 0);
          sec = parseFloat(m[3] || 0);
          let sign = 1;
          if (deg < 0) sign = -1;
          const valDec = Math.abs(deg) + (min || 0) / 60 + (sec || 0) / 3600;
          let out = sign * valDec;
          if (dir === "S" || dir === "W") out = -Math.abs(valDec);
          if (dir === "N" || dir === "E") out = Math.abs(valDec);
          return out;
        }
        const num = parseFloat(s.replace(",", "."));
        return isNaN(num) ? NaN : num;
      } catch (_) {
        return NaN;
      }
    },
    _parseCoordPair(input) {
      try {
        if (!input) return null;
        let s = String(input).trim();
        if (!s) return null;
        s = s.replace(/,/g, " ").replace(/\s+/g, " ").trim();
        const hasLat = /[NS]/i.test(s),
          hasLon = /[EW]/i.test(s);
        if (hasLat && hasLon) {
          const latIdx = s.search(/[NS]/i);
          if (latIdx > -1) {
            const latToken = s.slice(0, latIdx + 1).trim();
            const rest = s.slice(latIdx + 1).trim();
            const lonIdx = rest.search(/[EW]/i);
            const lonToken = lonIdx > -1 ? rest.slice(0, lonIdx + 1).trim() : rest;
            const lat = this._parseDMS(latToken);
            const lon = this._parseDMS(lonToken);
            if (isNaN(lat) || isNaN(lon)) return null;
            return { lat, lon };
          }
        }
        const nums = s.match(/-?\d+(?:\.\d+)?/g) || [];
        if (nums.length >= 2) {
          const lat = parseFloat(nums[0]);
          const lon = parseFloat(nums[1]);
          if (!isNaN(lat) && !isNaN(lon)) return { lat, lon };
        }
        return null;
      } catch (_) {
        return null;
      }
    },
    goToCoordsLot() {
      const parsed = this._parseCoordPair(this.coordInputLot);
      if (!parsed) {
        this.$fun &&
          this.$fun.toast &&
          this.$fun.toast("Formato de coordenadas inválido", "warning");
        return;
      }
      const { lat, lon } = parsed;
      // Siempre mostrar punto de vista previa (diferente al punto del lote)
      const inside = this._isPointInsideLot(lat, lon);
      this._updatePreviewPoint(lat, lon, {
        color: inside ? "#03a9f4" : "#ff9800",
        text: inside ? "Vista previa (dentro)" : "Vista previa (fuera)",
      });
      if (!inside) {
        this.$fun &&
          this.$fun.toast &&
          this.$fun.toast(
            "El punto pegado está fuera del polígono. Se muestra como vista previa.",
            "info"
          );
      }
      // Solo centramos/zoom; no cambiamos el punto oficial hasta confirmar
      this.lotMapCenter = [lat, lon];
      this.lotMapZoom = 18;
    },
    resetLotMapState() {
      try {
        const map = this.$refs.lotMap && this.$refs.lotMap.mapObject;
        if (map) {
          try {
            map.off(L.Draw.Event.CREATED);
          } catch (_) {}
          try {
            map.off(L.Draw.Event.EDITED);
          } catch (_) {}
          try {
            map.off("contextmenu");
          } catch (_) {}
        }
        if (map && this.lotDrawControl) {
          try {
            map.removeControl(this.lotDrawControl);
          } catch (_) {}
        }
        this.lotDrawControl = null;
        const layers = [
          "lotGeomLayer",
          "farmOutlineLayer",
          "parentLotOutlineLayer",
          "siblingsLayer",
          "otherLotsLayer",
          "lotPointInfoMarker",
          "previewPointLayer",
        ];
        for (const key of layers) {
          if (map && this[key]) {
            try {
              map.removeLayer(this[key]);
            } catch (_) {}
          }
          this[key] = null;
        }
        this.previewPoint = null;
        this.lotGeom = null;
        this.lotGeomValid = true;
        this.firstLotLayer = null;
      } catch (_) {}
    },
  openLotMap(item) {
      // Abrir modal interno (sin redirección) centrando según geometría/punto/padre
      this.currentLot = item;
      this.resetLotMapState();
      this.openingLotMap = true;
      const toDecimal = (s) => {
        if (s == null) return NaN;
        if (typeof s === "number") return s;
        const str = String(s).trim();
        if (!str.includes("°") && !/[NSEWnsew]/.test(str)) return parseFloat(str);
        const re = /([\d.]+)°\s*([\d.]+)?'?\s*([\d.]+)?"?\s*([NSEWnsew-])?/;
        const m = str.match(re);
        if (!m) return parseFloat(str);
        const deg = parseFloat(m[1] || 0),
          min = parseFloat(m[2] || 0),
          sec = parseFloat(m[3] || 0);
        let sign = 1;
        if (/S|s|W|w|-/.test(str)) sign = -1;
        return sign * (deg + min / 60 + sec / 3600);
      };
      const lat = toDecimal(item.FltLatituded),
        lon = toDecimal(item.FltLength);
      if (!isNaN(lat) && !isNaN(lon)) {
        // Normaliza los campos para que los inputs muestren decimales
        this.currentLot.FltLatituded = Number(lat).toFixed(6);
        this.currentLot.FltLength = Number(lon).toFixed(6);
        this.lotMapCenter = [lat, lon];
        this.lotMapZoom = 17;
      } else {
        this.lotMapCenter = [-5.19449, -80.63282];
        this.lotMapZoom = 15;
      }
      this.showLotMapModal = true;
      this.$nextTick(() => {
        const p = this.onLotMapReady();
        if (p && typeof p.finally === "function")
          p.finally(() => (this.openingLotMap = false));
        else this.openingLotMap = false;
      });
    },
    async onLotMapReady() {
      try {
        const map = this.$refs.lotMap && this.$refs.lotMap.mapObject;
        if (map) setTimeout(() => map.invalidateSize(), 200);
        const uid = this.$fun && this.$fun.getUserID ? this.$fun.getUserID() : 0;
        // Cargar contorno del Fundo
        if (map && this.agriculturalFarmID) {
          try {
            // pre-cargar info de lotes para tooltips (hectáreas/cultivo/variedad)
            try {
              const { data: list } = await _sFarmLot.getListAll(
                uid,
                this.agriculturalFarmID,
                true,
                ""
              );
              const info = new Map();
              if (Array.isArray(list)) {
                for (const l of list) {
                  const id = Number(l.FltID || l.id);
                  if (!id) continue;
                  info.set(id, {
                    name: l.FltName || l.nombre,
                    haDb: l.FltHectaresFull ?? l.FltHectares ?? null,
                    cultivo: l.CultiveText || l.TypeCultiveText || l.TypeCultive || "",
                    variedad: l.VrtIDText || l.VarietyText || "",
                  });
                }
              }
              this.lotInfoMap = info;
            } catch (_) {
              this.lotInfoMap = null;
              // console.log("Error pre-cargando info de lotes para tooltips");
              
            }
            const { data: farmFc } = await _sAgriculturalFarms.getFarmGeometryGeoJSON(
              this.agriculturalFarmID,
              uid
            );
            if (this.farmOutlineLayer) {
              try {
                map.removeLayer(this.farmOutlineLayer);
              } catch (_) {}
              this.farmOutlineLayer = null;
            }
            // console.log("farmFc", farmFc);
            if (farmFc && farmFc.features && farmFc.features.length > 0) {
              this.farmOutlineLayer = L.geoJSON(farmFc.features[0], {
                style: { color: "#1976d2", weight: 2, fillOpacity: 0 },
                onEachFeature: (feature, layer) => {
                  try {
                    // Calcular área y perímetro del fundo
                    let areaM2 = 0;
                    let perimeterM = 0;
                    const latlngs = layer.getLatLngs();
                    const rings = Array.isArray(latlngs[0]) 
                      ? (Array.isArray(latlngs[0][0]) ? latlngs : [latlngs])
                      : [[latlngs]];
                    
                    rings.forEach(polygon => {
                      const outerRing = polygon[0] || polygon;
                      if (outerRing && outerRing.length > 0) {
                        // Calcular área
                        const R = 6371000;
                        let sum = 0;
                        for (let i = 0; i < outerRing.length - 1; i++) {
                          const p1 = outerRing[i];
                          const p2 = outerRing[i + 1];
                          const lat1 = p1.lat * Math.PI / 180;
                          const lat2 = p2.lat * Math.PI / 180;
                          const lng1 = p1.lng * Math.PI / 180;
                          const lng2 = p2.lng * Math.PI / 180;
                          sum += (lng2 - lng1) * (2 + Math.sin(lat1) + Math.sin(lat2));
                        }
                        areaM2 += Math.abs(sum * R * R / 2);
                        
                        // Calcular perímetro
                        for (let i = 0; i < outerRing.length - 1; i++) {
                          perimeterM += outerRing[i].distanceTo(outerRing[i + 1]);
                        }
                        if (outerRing.length > 0) {
                          perimeterM += outerRing[outerRing.length - 1].distanceTo(outerRing[0]);
                        }
                      }
                    });
                    
                    const areaHa = (areaM2 / 10000).toFixed(2);
                    const perimeterKm = (perimeterM / 1000).toFixed(3);
                    const farmName = feature.properties?.FagName || feature.properties?.Name || 'Fundo';
                    
                    const html = `
                      <strong>${farmName} (Contorno)</strong><br/>
                      <strong>Área:</strong> ${areaHa} ha (${areaM2.toFixed(0)} m²)<br/>
                      <strong>Perímetro:</strong> ${perimeterKm} km (${perimeterM.toFixed(0)} m)
                    `;
                    layer.bindTooltip(html, { sticky: true });
                  } catch (_) {}
                }
              }).addTo(map);
            }
          } catch (e) {
            /* ignore */
          }
        }
        // Si es sublote, cargar contorno del lote padre y hermanos
        const parentId =
          this.currentLot && (this.currentLot.FkFltID || this.currentLot.FkFltIDText)
            ? this.currentLot.FkFltID
            : this.itemLot && this.itemLot.FkFltID;
        if (map && this.currentLot && this.currentLot.FltLevel == 2 && parentId) {
          try {
            // padre
            const { data: parentFc } = await _sFarmLot.getLotGeometryGeoJSONById(
              parentId,
              uid
            );
            if (this.parentLotOutlineLayer) {
              try {
                map.removeLayer(this.parentLotOutlineLayer);
              } catch (_) {}
              this.parentLotOutlineLayer = null;
            }
            // console.log("parentFc", parentFc);
            
            if (parentFc)
              this.parentLotOutlineLayer = L.geoJSON(parentFc, {
                style: { color: "#ff9800", weight: 2, dashArray: "4,4", fillOpacity: 0 },
              }).addTo(map);
            try {
              const grp = this.parentLotOutlineLayer;
              grp &&
                grp.eachLayer((l) => {
                  try {
                    const p = l.feature?.properties || {};
                    const id = Number(p.Id || p.id);
                    const d = this.lotInfoMap ? this.lotInfoMap.get(id) : null;
                    const n = (d && d.name) || p.Name || p.name || `Lote ${id || ""}`;
                    
                    // Calcular área y perímetro
                    let areaM2 = 0;
                    let perimeterM = 0;
                    const latlngs = l.getLatLngs();
                    const rings = Array.isArray(latlngs[0]) 
                      ? (Array.isArray(latlngs[0][0]) ? latlngs : [latlngs])
                      : [[latlngs]];
                    
                    rings.forEach(polygon => {
                      const outerRing = polygon[0] || polygon;
                      if (outerRing && outerRing.length > 0) {
                        // Calcular área
                        const R = 6371000;
                        let sum = 0;
                        for (let i = 0; i < outerRing.length - 1; i++) {
                          const p1 = outerRing[i];
                          const p2 = outerRing[i + 1];
                          const lat1 = p1.lat * Math.PI / 180;
                          const lat2 = p2.lat * Math.PI / 180;
                          const lng1 = p1.lng * Math.PI / 180;
                          const lng2 = p2.lng * Math.PI / 180;
                          sum += (lng2 - lng1) * (2 + Math.sin(lat1) + Math.sin(lat2));
                        }
                        areaM2 += Math.abs(sum * R * R / 2);
                        
                        // Calcular perímetro
                        for (let i = 0; i < outerRing.length - 1; i++) {
                          perimeterM += outerRing[i].distanceTo(outerRing[i + 1]);
                        }
                        if (outerRing.length > 0) {
                          perimeterM += outerRing[outerRing.length - 1].distanceTo(outerRing[0]);
                        }
                      }
                    });
                    
                    const areaHa = (areaM2 / 10000).toFixed(2);
                    const perimeterKm = (perimeterM / 1000).toFixed(3);
                    const haDb =
                      (d && d.haDb) != null ? d.haDb : p.FltHectaresFull ?? p.FltHectares;
                    
                    const parts = [
                      `<strong>${n} (Padre)</strong>`,
                      haDb != null ? `Hectáreas BD: ${Number(haDb).toFixed(2)} ha` : "",
                      `<strong>Área:</strong> ${areaHa} ha (${areaM2.toFixed(0)} m²)`,
                      `<strong>Perímetro:</strong> ${perimeterKm} km (${perimeterM.toFixed(0)} m)`,
                    ];
                    const html = parts.filter(Boolean).join("<br/>");
                    l.bindTooltip(html, { sticky: true });
                    l.on("mouseover", () => {
                      try {
                        l.openTooltip();
                      } catch (_) {}
                    });
                  } catch (_) {}
                });
            } catch (_) {}
            // hermanos
            const { data: sibFc } = await _sFarmLot.getSublotsGeometryGeoJSONByParent(
              parentId,
              uid
            );
            if (this.siblingsLayer) {
              try {
                map.removeLayer(this.siblingsLayer);
              } catch (_) {}
              this.siblingsLayer = null;
            }
            if (sibFc && sibFc.features && sibFc.features.length > 0)
              this.siblingsLayer = L.geoJSON(sibFc, {
                style: { color: "#9c27b0", weight: 1, dashArray: "2,6", fillOpacity: 0 },
              }).addTo(map);
            try {
              const grp = this.siblingsLayer;
              grp &&
                grp.eachLayer((l) => {
                  try {
                    const p = l.feature?.properties || {};
                    const id = Number(p.Id || p.id);
                    const d = this.lotInfoMap ? this.lotInfoMap.get(id) : null;
                    const n = (d && d.name) || p.Name || p.name || `Sublote ${id || ""}`;
                    
                    // Calcular área y perímetro
                    let areaM2 = 0;
                    let perimeterM = 0;
                    const latlngs = l.getLatLngs();
                    const rings = Array.isArray(latlngs[0]) 
                      ? (Array.isArray(latlngs[0][0]) ? latlngs : [latlngs])
                      : [[latlngs]];
                    
                    rings.forEach(polygon => {
                      const outerRing = polygon[0] || polygon;
                      if (outerRing && outerRing.length > 0) {
                        // Calcular área
                        const R = 6371000;
                        let sum = 0;
                        for (let i = 0; i < outerRing.length - 1; i++) {
                          const p1 = outerRing[i];
                          const p2 = outerRing[i + 1];
                          const lat1 = p1.lat * Math.PI / 180;
                          const lat2 = p2.lat * Math.PI / 180;
                          const lng1 = p1.lng * Math.PI / 180;
                          const lng2 = p2.lng * Math.PI / 180;
                          sum += (lng2 - lng1) * (2 + Math.sin(lat1) + Math.sin(lat2));
                        }
                        areaM2 += Math.abs(sum * R * R / 2);
                        
                        // Calcular perímetro
                        for (let i = 0; i < outerRing.length - 1; i++) {
                          perimeterM += outerRing[i].distanceTo(outerRing[i + 1]);
                        }
                        if (outerRing.length > 0) {
                          perimeterM += outerRing[outerRing.length - 1].distanceTo(outerRing[0]);
                        }
                      }
                    });
                    
                    const areaHa = (areaM2 / 10000).toFixed(2);
                    const perimeterKm = (perimeterM / 1000).toFixed(3);
                    const haDb =
                      (d && d.haDb) != null ? d.haDb : p.FltHectaresFull ?? p.FltHectares;
                    
                    const parts = [
                      `<strong>${n} (Hermano)</strong>`,
                      haDb != null ? `Hectáreas BD: ${Number(haDb).toFixed(2)} ha` : "",
                      `<strong>Área:</strong> ${areaHa} ha (${areaM2.toFixed(0)} m²)`,
                      `<strong>Perímetro:</strong> ${perimeterKm} km (${perimeterM.toFixed(0)} m)`,
                    ];
                    const html = parts.filter(Boolean).join("<br/>");
                    l.bindTooltip(html, { sticky: true });
                    l.on("mouseover", () => {
                      try {
                        l.openTooltip();
                      } catch (_) {}
                    });
                  } catch (_) {}
                });
            } catch (_) {
              console.log("no siblings tooltip");
              
            }
          } catch (e) {
            console.log("no parent/siblings", e);
            
          }
        }
        // Otros lotes del mismo Fundo (solo cuando NO es sublote)
        if (map && this.currentLot && this.currentLot.FltLevel != 2 && this.agriculturalFarmID) {
          try {
            // Usamos lotInfoMap (ya cargado arriba) para obtener los IDs
            const ids = this.lotInfoMap ? Array.from(this.lotInfoMap.keys()) : [];
            const currentId = Number(this.currentLot.FltID);
            const others = ids.filter((id) => Number(id) && Number(id) !== currentId);
            if (this.otherLotsLayer) {
              try { map.removeLayer(this.otherLotsLayer); } catch (_) {}
              this.otherLotsLayer = null;
            }
            const group = L.layerGroup();
            // Traer geometrías de los otros lotes y pintarlas como contornos
            const uid2 = this.$fun && this.$fun.getUserID ? this.$fun.getUserID() : 0;
            const tasks = others.map(async (id) => {
              try {
                const { data: fc } = await _sFarmLot.getLotGeometryGeoJSONById(id, uid2);
                if (!fc) return;
                const layer = L.geoJSON(fc, {
                  style: { color: "#9e9e9e", weight: 1, dashArray: "2,6", fillOpacity: 0 },
                });
                // tooltip con info calculando área y perímetro
                try {
                  const d = this.lotInfoMap ? this.lotInfoMap.get(Number(id)) : null;
                  const n = (d && d.name) || `Lote ${id}`;
                  const haDb = d && d.haDb;
                  
                  layer.eachLayer((poly) => {
                    try {
                      // Calcular área y perímetro
                      let areaM2 = 0;
                      let perimeterM = 0;
                      const latlngs = poly.getLatLngs();
                      const rings = Array.isArray(latlngs[0]) 
                        ? (Array.isArray(latlngs[0][0]) ? latlngs : [latlngs])
                        : [[latlngs]];
                      
                      rings.forEach(polygon => {
                        const outerRing = polygon[0] || polygon;
                        if (outerRing && outerRing.length > 0) {
                          // Calcular área
                          const R = 6371000;
                          let sum = 0;
                          for (let i = 0; i < outerRing.length - 1; i++) {
                            const p1 = outerRing[i];
                            const p2 = outerRing[i + 1];
                            const lat1 = p1.lat * Math.PI / 180;
                            const lat2 = p2.lat * Math.PI / 180;
                            const lng1 = p1.lng * Math.PI / 180;
                            const lng2 = p2.lng * Math.PI / 180;
                            sum += (lng2 - lng1) * (2 + Math.sin(lat1) + Math.sin(lat2));
                          }
                          areaM2 += Math.abs(sum * R * R / 2);
                          
                          // Calcular perímetro
                          for (let i = 0; i < outerRing.length - 1; i++) {
                            perimeterM += outerRing[i].distanceTo(outerRing[i + 1]);
                          }
                          if (outerRing.length > 0) {
                            perimeterM += outerRing[outerRing.length - 1].distanceTo(outerRing[0]);
                          }
                        }
                      });
                      
                      const areaHa = (areaM2 / 10000).toFixed(2);
                      const perimeterKm = (perimeterM / 1000).toFixed(3);
                      
                      const parts = [
                        `<strong>${n} (Otro lote)</strong>`,
                        haDb != null ? `Hectáreas BD: ${Number(haDb).toFixed(2)} ha` : "",
                        `<strong>Área:</strong> ${areaHa} ha (${areaM2.toFixed(0)} m²)`,
                        `<strong>Perímetro:</strong> ${perimeterKm} km (${perimeterM.toFixed(0)} m)`,
                      ].filter(Boolean);
                      const html = parts.join("<br/>");
                      poly.bindTooltip(html, { sticky: true });
                    } catch (_) {}
                  });
                } catch (_) {}
                group.addLayer(layer);
              } catch (_) {}
            });
            await Promise.all(tasks);
            this.otherLotsLayer = group.addTo(map);
          } catch (_) {}
        }
        // Cargar geometría del lote
        if (this.currentLot && this.currentLot.FltID && map) {
          const { data: fc } = await _sFarmLot.getLotGeometryGeoJSONById(
            this.currentLot.FltID,
            uid
          );
          // limpiar capa anterior siempre
          if (this.lotGeomLayer) {
            try {
              map.removeLayer(this.lotGeomLayer);
            } catch (_) {}
            this.lotGeomLayer = null;
          }
          // crear capa SOLO si hay features/geom válidos
          const hasFeatures = !!(
            fc &&
            ((fc.type === "FeatureCollection" && fc.features && fc.features.length > 0) ||
              fc.type === "Feature" ||
              fc.type === "Polygon" ||
              fc.type === "MultiPolygon")
          );
          if (hasFeatures) {
            // Pintar polígonos del lote, resaltando solo el que coincida con el FltID actual
            const currentId = Number(this.currentLot?.FltID);
            this.firstLotLayer = null;
            this.lotGeomLayer = L.geoJSON(fc, {
              onEachFeature: (feature, layer) => {
                const p = (feature && feature.properties) || {};
                const featureColor =
                  (p.color || p.Color) ||
                  (this.currentLot && this.currentLot.color) ||
                  "#43a047";
                try {
                  layer.setStyle({ color: featureColor, fillColor: featureColor, weight: 2, fillOpacity: 0.2 });
                } catch (_) {}
                const fid = Number(p.FltID ?? p.fltid ?? p.Id ?? p.ID ?? p.id ?? p.LotId ?? p.lotId);
                if (!isNaN(fid) && fid === currentId && !this.firstLotLayer) {
                  try { layer.setStyle({ color: "#ffffff", fillColor: "#ffffff", weight: 2, fillOpacity: 0.35 }); } catch (_) {}
                  this.firstLotLayer = layer;
                }
              },
            }).addTo(map);
            try {
              // Calcular área y perímetro para CADA polígono individualmente
              this.lotGeomLayer.eachLayer((poly) => {
                try {
                  // Obtener propiedades específicas de ESTE polígono
                  const props = poly.feature?.properties || {};
                  const fid = Number(props.FltID ?? props.fltid ?? props.Id ?? props.ID ?? props.id ?? props.LotId ?? props.lotId);
                  
                  // Buscar info en lotInfoMap si existe
                  const lotData = this.lotInfoMap && !isNaN(fid) ? this.lotInfoMap.get(fid) : null;
                  
                  // Usar propiedades del polígono, luego lotInfoMap, y finalmente currentLot como fallback
                  const n = props.FltName || props.Name || props.name || (lotData && lotData.name) || 
                           (fid && fid === Number(this.currentLot?.FltID) ? this.currentLot?.FltName : null) || 
                           `Lote ${fid || ''}`;
                  
                  const cultivo = props.CultiveText || props.Cultive || props.cultive || 
                                 (lotData && lotData.cultive) ||
                                 (fid && fid === Number(this.currentLot?.FltID) ? this.currentLot?.CultiveText || this.currentLot?.TypeCultive : null) || 
                                 "";
                  
                  const variedad = props.VrtIDText || props.Variety || props.variety || 
                                  (lotData && lotData.variety) ||
                                  (fid && fid === Number(this.currentLot?.FltID) ? this.currentLot?.VrtIDText : null) || 
                                  "";
                  
                  const haDb = props.FltHectaresFull ?? props.FltHectares ?? props.Hectares ?? 
                              (lotData && lotData.haDb) ??
                              (fid && fid === Number(this.currentLot?.FltID) ? this.currentLot?.FltHectaresFull ?? this.currentLot?.FltHectares : null);
                  
                  let areaM2 = 0;
                  let perimeterM = 0;
                  
                  const latlngs = poly.getLatLngs();
                  // Normalizar estructura (puede ser [[coords]] o [[[coords]]])
                  const rings = Array.isArray(latlngs[0]) 
                    ? (Array.isArray(latlngs[0][0]) ? latlngs : [latlngs])
                    : [[latlngs]];
                  
                  rings.forEach(polygon => {
                    const outerRing = polygon[0] || polygon;
                    if (outerRing && outerRing.length > 0) {
                      // Calcular área usando fórmula geodésica
                      const R = 6371000; // Radio de la Tierra en metros
                      let sum = 0;
                      for (let i = 0; i < outerRing.length - 1; i++) {
                        const p1 = outerRing[i];
                        const p2 = outerRing[i + 1];
                        const lat1 = p1.lat * Math.PI / 180;
                        const lat2 = p2.lat * Math.PI / 180;
                        const lng1 = p1.lng * Math.PI / 180;
                        const lng2 = p2.lng * Math.PI / 180;
                        sum += (lng2 - lng1) * (2 + Math.sin(lat1) + Math.sin(lat2));
                      }
                      areaM2 += Math.abs(sum * R * R / 2);
                      
                      // Calcular perímetro
                      for (let i = 0; i < outerRing.length - 1; i++) {
                        perimeterM += outerRing[i].distanceTo(outerRing[i + 1]);
                      }
                      // Cerrar el polígono
                      if (outerRing.length > 0) {
                        perimeterM += outerRing[outerRing.length - 1].distanceTo(outerRing[0]);
                      }
                    }
                  });
                  
                  const areaHa = (areaM2 / 10000).toFixed(2);
                  const perimeterKm = (perimeterM / 1000).toFixed(3);
                  
                  const parts = [
                    `<strong>${n}</strong>`,
                    cultivo ? `Cultivo: ${cultivo}` : "",
                    variedad ? `Variedad: ${variedad}` : "",
                    haDb != null ? `Hectáreas BD: ${Number(haDb).toFixed(2)} ha` : "",
                    `<strong>Área:</strong> ${areaHa} ha (${areaM2.toFixed(0)} m²)`,
                    `<strong>Perímetro:</strong> ${perimeterKm} km (${perimeterM.toFixed(0)} m)`,
                  ];
                  const html = parts.filter(Boolean).join("<br/>");
                  
                  poly.bindTooltip(html, { 
                    sticky: true,
                    className: 'lot-polygon-tooltip'
                  });
                  poly.on("mouseover", () => {
                    try {
                      poly.openTooltip();
                    } catch (_) {}
                  });
                } catch (e) {
                  console.error("Error calculando área/perímetro del lote:", e);
                }
              });
            } catch (_) {}
            // validar sublote dentro del padre si aplica
            this.lotGeomValid = this.validateSubWithinParent(this.lotGeomLayer);
            if (!this.lotGeomValid) {
              try {
                this.lotGeomLayer.setStyle({ color: "#e53935" });
              } catch (_) {}
            }
            try {
              map.fitBounds(this.lotGeomLayer.getBounds(), { maxZoom: 19 });
            } catch (_) {}
          } else {
            // Sin geometría de lote: si hay punto válido, marcarlo y tooltip; si no, centrar a fundo/pIanta
            try {
              const lat = parseFloat(
                String(this.currentLot?.FltLatituded || "").replace(",", ".")
              );
              const lng = parseFloat(
                String(this.currentLot?.FltLength || "").replace(",", ".")
              );
              if (!isNaN(lat) && !isNaN(lng)) {
                if (this.lotPointInfoMarker) {
                  try {
                    map.removeLayer(this.lotPointInfoMarker);
                  } catch (_) {}
                  this.lotPointInfoMarker = null;
                }
                const m = L.circleMarker([lat, lng], {
                  radius: 6,
                  color: "#1565C0",
                  fillColor: "#42A5F5",
                  fillOpacity: 0.9,
                });
                const n = this.currentLot?.FltName || `Lote ${this.currentLot?.FltID}`;
                const cultivo =
                  this.currentLot?.CultiveText || this.currentLot?.TypeCultive || "";
                const variedad = this.currentLot?.VrtIDText || "";
                const html = [
                  `<strong>${n}</strong>`,
                  cultivo ? `Cultivo: ${cultivo}` : "",
                  variedad ? `Variedad: ${variedad}` : "",
                  `Lat: ${lat.toFixed(6)} • Lon: ${lng.toFixed(6)}`,
                ]
                  .filter(Boolean)
                  .join("<br/>");
                try {
                  m.bindTooltip(html, { sticky: true });
                  m.on("mouseover", () => {
                    try {
                      m.openTooltip();
                    } catch (_) {}
                  });
                } catch (_) {}
                this.lotPointInfoMarker = m.addTo(map);
                map.setView([lat, lng], 17);
              } else if (this.farmOutlineLayer) {
                map.fitBounds(this.farmOutlineLayer.getBounds(), { maxZoom: 18 });
              } else {
                // fallback: intentar centrar a punto del fundo o planta
                this.centerToFarm();
              }
            } catch (_) {
              this.centerToFarm();
            }
          }
        } else if (this.farmOutlineLayer) {
          try {
            map.fitBounds(this.farmOutlineLayer.getBounds(), { maxZoom: 18 });
          } catch (_) {}
        } else {
          this.centerToFarm();
        }
      } catch (_) {}
    },
    onLotMapClick(e) {
      if (!this.currentLot) return;
      const { lat, lng } = e.latlng;
      const inside = this._isPointInsideLot(lat, lng);
      this._updatePreviewPoint(lat, lng, {
        color: inside ? "#4caf50" : "#f44336",
        text: inside ? "Punto válido" : "Punto fuera de polígono",
      });
      if (inside) {
        this._setLotPointIfValid(lat, lng);
      } else {
        this.$fun &&
          this.$fun.toast &&
          this.$fun.toast("El punto debe estar dentro del polígono del lote", "warning");
      }
    },
    async startLotDraw() {
      try {
        const map = this.$refs.lotMap && this.$refs.lotMap.mapObject;
        if (!map) return;
        // Validar que el Fundo tenga polígono y, si es sublote, que exista polígono del padre
        const uid = this.$fun && this.$fun.getUserID ? this.$fun.getUserID() : 0;
        const { data: farmFc } = await _sAgriculturalFarms.getFarmGeometryGeoJSON(
          this.agriculturalFarmID,
          uid
        );
        if (!farmFc || !farmFc.features || farmFc.features.length === 0) {
          this.$fun && this.$fun.alert("Primero dibuje el polígono del Fundo", "warning");
          return;
        }
        if (this.currentLot && this.currentLot.FltLevel == 2 && this.currentLot.FkFltID) {
          const { data: parentFc } = await _sFarmLot.getLotGeometryGeoJSONById(
            this.currentLot.FkFltID,
            uid
          );
          if (!parentFc || (parentFc.features && parentFc.features.length === 0)) {
            this.$fun &&
              this.$fun.alert(
                "El Lote padre no tiene polígono. Dibújalo antes de crear el sublote",
                "warning"
              );
            return;
          }
        }
        if (this.lotDrawControl) {
          try {
            map.removeControl(this.lotDrawControl);
          } catch (_) {}
        }
        this.lotGeom = null;
        this.lotDrawControl = new L.Control.Draw({
          draw: {
            polygon: { showArea: true, allowIntersection: false },
            rectangle: false,
            polyline: false,
            circle: false,
            marker: false,
            circlemarker: false,
          },
          edit: false,
        });
        map.addControl(this.lotDrawControl);
        const onCreated = (e) => {
          try {
            const gj = e.layer && e.layer.toGeoJSON ? e.layer.toGeoJSON() : null;
            this.lotGeom = gj ? gj.geometry : null;
            if (this.lotGeomLayer) {
              try {
                map.removeLayer(this.lotGeomLayer);
              } catch (_) {}
              this.lotGeomLayer = null;
            }
            this.lotGeomLayer = L.geoJSON(gj, {
              style: { color: "#43a047", weight: 2, fillOpacity: 0.2 },
            }).addTo(map);
            try {
              // área calculada
              let total = 0;
              this.lotGeomLayer.eachLayer((poly) => {
                try {
                  const latlngs = poly.getLatLngs();
                  const rings = Array.isArray(latlngs[0]) ? latlngs[0] : latlngs;
                  total +=
                    L.GeometryUtil && L.GeometryUtil.geodesicArea
                      ? L.GeometryUtil.geodesicArea(rings[0] || rings)
                      : 0;
                } catch (_) {}
              });
              const areaTxt =
                total > 0
                  ? `${(total / 10000).toFixed(2)} ha (${(total / 1e6).toFixed(2)} km²)`
                  : "";
              const n = this.currentLot?.FltName || `Lote ${this.currentLot?.FltID}`;
              const cultivo =
                this.currentLot?.CultiveText || this.currentLot?.TypeCultive || "";
              const variedad = this.currentLot?.VrtIDText || "";
              const parts = [
                `<strong>${n}</strong>`,
                cultivo ? `Cultivo: ${cultivo}` : "",
                variedad ? `Variedad: ${variedad}` : "",
                areaTxt ? `Área mapa: ${areaTxt}` : "",
              ];
              const html = parts.filter(Boolean).join("<br/>");
              this.lotGeomLayer.eachLayer((l) => {
                try {
                  l.bindTooltip(html, { sticky: true });
                } catch (_) {}
              });
            } catch (_) {}
            // validar sublote
            this.lotGeomValid = this.validateSubWithinParent(this.lotGeomLayer);
            if (!this.lotGeomValid) {
              try {
                this.lotGeomLayer.setStyle({ color: "#e53935" });
              } catch (_) {}
              this.$fun &&
                this.$fun.toast &&
                this.$fun.toast(
                  "El sublote debe estar contenido en su lote padre",
                  "warning"
                );
            }
            try {
              map.fitBounds(this.lotGeomLayer.getBounds(), { maxZoom: 19 });
            } catch (_) {}
          } catch (_) {}
          map.off(L.Draw.Event.CREATED, onCreated);
          // Permitir que el usuario edite si quedó inválido
          if (!this.lotGeomValid) {
            try {
              map.removeControl(this.lotDrawControl);
            } catch (_) {}
            this.lotDrawControl = new L.Control.Draw({
              draw: false,
              edit: {
                featureGroup: (() => {
                  const target =
                    this.firstLotLayer ||
                    (this.lotGeomLayer &&
                      this.lotGeomLayer.getLayers &&
                      this.lotGeomLayer.getLayers()[0]);
                  return L.featureGroup(target ? [target] : []);
                })(),
                edit: true,
                remove: false,
              },
            });
            map.addControl(this.lotDrawControl);
            const onEditedFix = (ev) => {
              try {
                ev.layers.eachLayer((layer) => {
                  this.lotGeomValid = this.validateSubWithinParent(layer);
                  if (this.lotGeomValid) {
                    layer.setStyle({ color: "#43a047" });
                    this.lotGeom = layer.toGeoJSON().geometry;
                  } else {
                    layer.setStyle({ color: "#e53935" });
                  }
                });
              } catch (_) {}
              if (this.lotGeomValid) {
                map.off(L.Draw.Event.EDITED, onEditedFix);
                try {
                  map.removeControl(this.lotDrawControl);
                } catch (_) {}
                this.lotDrawControl = null;
              }
            };
            map.on(L.Draw.Event.EDITED, onEditedFix);
          } else {
            try {
              map.removeControl(this.lotDrawControl);
            } catch (_) {}
            this.lotDrawControl = null;
          }
        };
        map.on(L.Draw.Event.CREATED, onCreated);
      } catch (_) {}
    },

    startLotEdit() {
      try {
        const map = this.$refs.lotMap && this.$refs.lotMap.mapObject;
        if (!map || !this.lotGeomLayer) return;
        // preparar featureGroup SOLO con el primer polígono
        const first =
          this.firstLotLayer ||
          (this.lotGeomLayer &&
            this.lotGeomLayer.getLayers &&
            this.lotGeomLayer.getLayers()[0]);
        const fg = L.featureGroup(first ? [first] : []);
        if (this.lotDrawControl) {
          try {
            map.removeControl(this.lotDrawControl);
          } catch (_) {}
          this.lotDrawControl = null;
        }
        this.lotDrawControl = new L.Control.Draw({
          draw: false,
          edit: { featureGroup: fg, edit: true, remove: false },
        });
        map.addControl(this.lotDrawControl);
        const onEdited = (e) => {
          try {
            e.layers.eachLayer((layer) => {
              const gj = layer.toGeoJSON();
              this.lotGeomValid = this.validateSubWithinParent(layer);
              if (this.lotGeomValid) {
                this.lotGeom = gj.geometry;
                layer.setStyle({ color: "#43a047" });
              } else {
                layer.setStyle({ color: "#e53935" });
                this.$fun &&
                  this.$fun.toast &&
                  this.$fun.toast(
                    "El sublote debe estar contenido en su lote padre",
                    "warning"
                  );
              }
            });
          } catch (_) {}
          if (this.lotGeomValid) {
            map.off(L.Draw.Event.EDITED, onEdited);
            try {
              map.removeControl(this.lotDrawControl);
            } catch (_) {}
            this.lotDrawControl = null;
          }
        };
        map.on(L.Draw.Event.EDITED, onEdited);
      } catch (_) {}
    },

    useMyLocationLot() {
      if (!navigator.geolocation) return;
      this.locating = true;
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const lat = pos.coords.latitude;
          const lon = pos.coords.longitude;
          this._setLotPointIfValid(lat, lon);
          this.lotMapCenter = [parseFloat(lat), parseFloat(lon)];
          this.lotMapZoom = 18;
          this.locating = false;
        },
        () => {
          this.locating = false;
        },
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
      );
    },
    centerToFarm() {
      try {
        const map = this.$refs.lotMap && this.$refs.lotMap.mapObject;
        if (!map) return;
        const fid = this.agriculturalFarmID || (this.currentLot && this.currentLot.FagID);

        if (!fid) return;
        const uid = this.$fun && this.$fun.getUserID ? this.$fun.getUserID() : 0;
        const toDecimal = (s) => {
          if (s == null) return NaN;
          if (typeof s === "number") return s;
          const str = String(s).trim();
          if (!str.includes("°") && !/[NSEWnsew]/.test(str)) return parseFloat(str);
          const re = /(\d+(?:\.\d+)?)°\s*(\d+(?:\.\d+)?)?'?\s*(\d+(?:\.\d+)?)?"?\s*([NSEWnsew-])?/;
          const m = str.match(re);
          if (!m) return parseFloat(str);
          const deg = parseFloat(m[1] || 0),
            min = parseFloat(m[2] || 0),
            sec = parseFloat(m[3] || 0);
          let sign = 1;
          if (/S|s|W|w|-/.test(str)) sign = -1;
          return sign * (deg + min / 60 + sec / 3600);
        };
        _sAgriculturalFarms
          .getFarmGeometryGeoJSON(fid, uid)
          .then(({ data: fc }) => {
            if (fc && fc.features && fc.features.length > 0) {
              const layer = L.geoJSON(fc, {
                style: { color: "#1976d2", weight: 1, fillOpacity: 0 },
              });
              try {
                map.addLayer(layer);
                map.fitBounds(layer.getBounds(), { maxZoom: 18 });
              } catch (_) {}
              setTimeout(() => {
                try {
                  map.removeLayer(layer);
                } catch (_) {}
              }, 1200);
            } else {
              try {
                const lat = toDecimal(this.currentLot?.FltLatitude);
                const lng = toDecimal(this.currentLot?.FltLength);
                if (!isNaN(lat) && !isNaN(lng)) map.setView([lat, lng], 17);
                else map.setView([this.plant.lat, this.plant.lng], 15);
              } catch (_) {
                map.setView([this.plant.lat, this.plant.lng], 15);
                this.$fun &&
                  this.$fun.toast &&
                  this.$fun.toast(
                    "No se pudo centrar al Fundo (sin polígono definido)",
                    "warning"
                  );
              }
            }
          })
          .catch(() => {
            map.setView([this.plant.lat, this.plant.lng], 15);
          });
      } catch (_) {}
    },

    async saveLotGeometry() {
      if (!this.currentLot || !this.currentLot.FltID || !this.lotGeom) return;
      if (this.isSublote && !this.lotGeomValid) {
        this.$fun &&
          this.$fun.alert(
            "El sublote no es válido (fuera del lote padre). Corrige antes de guardar",
            "warning"
          );
        return;
      }
      const uid = this.$fun && this.$fun.getUserID ? this.$fun.getUserID() : 0;
      await _sFarmLot.refreshCacheLotGeometry(this.currentLot.FltID, this.lotGeom, uid);
      this.$fun && this.$fun.toast && this.$fun.toast("Geometría guardada", "success");
      this.lotGeom = null;
      // recargar capa
      this.$nextTick(this.onLotMapReady);
    },

    async confirmLotLocation() {
      try {
        if (!this.currentLot || !this.currentLot.FltID) {
          this.showLotMapModal = false;
          return;
        }
        // Preferir la vista previa si existe; si no, normalizar inputs individuales (DMS o decimal)
        let lat, lng;
        if (this.previewPoint) {
          lat = parseFloat(this.previewPoint.lat);
          lng = parseFloat(this.previewPoint.lon);
          // reflejar en el modelo con 6 decimales
          this.currentLot.FltLatituded = Number(lat).toFixed(6);
          this.currentLot.FltLength = Number(lng).toFixed(6);
        } else {
          const tmp = {
            FltLatituded: this.currentLot.FltLatituded,
            FltLength: this.currentLot.FltLength,
          };
          if (!this._normalizeCoords(tmp)) {
            this.$fun && this.$fun.toast && this.$fun.toast("Coordenadas inválidas", "warning");
            return;
          }
          lat = parseFloat(String(tmp.FltLatituded).replace(",", "."));
          lng = parseFloat(String(tmp.FltLength).replace(",", "."));
          this.currentLot.FltLatituded = tmp.FltLatituded;
          this.currentLot.FltLength = tmp.FltLength;
        }

        if (isNaN(lat) || isNaN(lng)) {
          this.$fun && this.$fun.toast && this.$fun.toast("Coordenadas inválidas", "warning");
          return;
        }

        // Validar punto dentro del polígono si existe
        if (!this._isPointInsideLot(lat, lng)) {
          this.$fun &&
            this.$fun.alert &&
            this.$fun.alert("El punto está fuera del polígono del lote", "warning");
          return;
        }

        const uid = this.$fun && this.$fun.getUserID ? this.$fun.getUserID() : 0;
        await _sFarmLot.refreshCacheLotPoint(this.currentLot, uid);
      } catch (e) {
        // console.error("Actualizar punto lote", e);
      }
      this._clearPreviewPoint();
      this.showLotMapModal = false;
    },
    getDataRefreshPlants(items) {
      const result = items.reduce(
        (acc, curr) => {
          acc.totalPlants += curr.FltPlants;
          const year = parseInt(curr.FltSowingYear);
          if (year < acc.oldestYear) acc.oldestYear = year;
          return acc;
        },
        { totalPlants: 0, oldestYear: Infinity }
      );

      this.dataPlants.FltPlants = result.totalPlants;
      this.dataPlants.FltSowingYear = result.oldestYear;
    },
    openDialogPlants(FltID) {
      this.FltID = FltID;
      this.openDialogViewPlants = true;
    },
    inputLot(lot, item) {
      if (lot) {
        item.TypeCrop = lot.TypeCrop;
        item.VrtID = lot.VrtID;
        item.TypeCultive = lot.TypeCultive;
      }
    },
    Initialize() {
      this.filter = { FagID: this.agriculturalFarmID };
      this.$refs.crud2.refresh();
    },

     _normalizeCoords(item) {
      return this.$fun && this.$fun.normalizeCoords
        ? this.$fun.normalizeCoords(item, "FltLatituded", "FltLength", 6)
        : true;
    },
    edit(item) {
      this.ObjLot = null;
      const row = item[0] || this.itemLot;
      if (!row) return;
      // Si es sublote (FltLevel=2), preseleccionar el lote padre en el selector

      if (row.FltLevel == 2 && row.FkFltID) {
        this.ObjLot = {
          FltID: row.FkFltID,
          FltName: row.FkFltIDText || `Lote ${row.FkFltID}`,
        };
      } else {
        this.ObjLot = {};
      }
    },

    save(itemBK) {
      const item = { ...itemBK };
      // Normalizar/validar lat/lon antes de cualquier otra validación
      if (!this._normalizeCoords(item)) return;
      item.FagID = this.agriculturalFarmID;
      item.TypeVariety = item.VrtID;
      item.FltPlants = this.dataPlants.FltPlants;
      item.FltSowingYear = this.dataPlants.FltSowingYear;

      if (item.FltLevel == 2) {
        item.FkFltID =
          this.ObjLot && this.ObjLot.FltID ? this.ObjLot.FltID : item.FkFltID;
        if (!item.FkFltID) {
          this.$fun.alert("Ingrese Lote Padre", "warning");
          return;
        }
        if (item.FltID && item.FltID === item.FkFltID) {
          this.$fun.alert("El Lote Padre no puede ser el mismo sublote", "warning");
          return;
        }
      }
      if (item.FltName.length == 0) {
        this.$fun.alert("Ingrese un Nombre para el Lote", "warning");
        return;
      }
      if (item.FltLevel == 0) {
        this.$fun.alert("Seleccione un Nivel del Lote", "warning");
        return;
      }
      if (item.TypeCrop == 0) {
        this.$fun.alert("Seleccione Tipo de Fruta", "warning");
        return;
      }
      if (item.TypeCultive == 0) {
        this.$fun.alert("Selecciona un Cultivo", "warning");
      }
      if (item.FltHectares.length == 0) {
        this.$fun.alert("Registre Cantidad de Hectareas", "warning");
        return;
      }
      if (item.FltLevel == 2 && item.DefID == "") {
        this.$fun.alert("Seleccione el lote", "warning");
        return;
      }
      if (item.TypeCultive == 0 && item.DefID == null) {
        this.$fun.alert("Seleccione un tipo de variedad", "warning");
        return;
      }
      /* if (item.TypeCrop == 2 && item.FltCodeOrganic == '') {
        this.$fun.alert("Ingrese el Código Orgánico", "warning");
        return;
      }*/
      if (item.PrdID == 0 || item.PrdID == null) {
        this.$fun.alert("Seleccione Productor", "warning");
        return;
      }

      item.UsrUpdateID = this.$fun.getUserID();
      item.UsrCreateID = this.$fun.getUserID();

      this.$fun.alert("Seguro de Guardar", "question").then((r) => {
        if (r.value) {
          _sFarmLot.save(item, this.$fun.getUserID()).then((resp) => {
            if (resp.status == 200) {
              this.$fun.alert("Actualizado Correctamente", "success");
              this.$refs.crud2.refresh();
              this.ObjLot = null;
            }
          });
        }
      });
    },

    // --- Validación cliente: sublote dentro de lote padre ---
    validateSubWithinParent(layer) {
      try {
        if (!this.isSublote) return true;
        const parent = this.parentLotOutlineLayer;
        if (!parent) return true; // sin contorno, no bloquear en cliente
        // obtener anillos del padre (tomamos el primero)
        let parentRings = [];
        parent.eachLayer((l) => {
          try {
            const rings = l.getLatLngs();
            if (Array.isArray(rings)) parentRings = parentRings.concat(rings);
          } catch (_) {}
        });
        if (parentRings.length === 0) return true;
        // exterior del primer polígono
        const poly = parentRings[0][0] ? parentRings[0] : parentRings[0];
        const pts =
          layer.getLatLngs && layer.getLatLngs()[0] ? layer.getLatLngs()[0] : [];
        for (const p of pts) {
          if (!this.pointInPolygon(p, poly)) return false;
        }
        return true;
      } catch (_) {
        return true;
      }
    },
    pointInPolygon(pt, poly) {
      // Ray casting en lat/lng
      let x = pt.lng,
        y = pt.lat;
      let inside = false;
      const vs = poly.map((ll) => ({ x: ll.lng, y: ll.lat }));
      for (let i = 0, j = vs.length - 1; i < vs.length; j = i++) {
        const xi = vs[i].x,
          yi = vs[i].y,
          xj = vs[j].x,
          yj = vs[j].y;
        const intersect =
          yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi + 0.0) + xi;
        if (intersect) inside = !inside;
      }
      return inside;
    },

    rowSelectedFarmsLot(items) {
      if (items.length > 0) {
        this.itemLot = items[0];
        this.dataPlants.FltPlants = items[0].FltPlants;
        this.dataPlants.FltSowingYear = items[0].FltSowingYear;

        const lat = this.itemLot?.FltLatituded;
        const lng = this.itemLot?.FltLength;

        // parse decimal o DMS
        // const toDecimal = (s) => {
    const toDecimal = (s) => (this.$fun && this.$fun.toDecimalCoord ? this.$fun.toDecimalCoord(s) : parseFloat(s));
        if (lat && lng && String(lat).includes("°") && String(lng).includes("°")) {
          this.FltLatitudedLenght = [lat, lng];
          this.mapLat = null;
          this.mapLng = null;
        } else {
          const latD = toDecimal(lat),
            lngD = toDecimal(lng);
          if (!isNaN(latD) && !isNaN(lngD)) {
            this.mapLat = latD;
            this.mapLng = lngD;
            this.FltLatitudedLenght = [];
          } else {
            this.mapLat = null;
            this.mapLng = null;
            this.FltLatitudedLenght = [];
          }
        }
        this.ObjLot = null;
      } else {
        this.itemLot = null;
      }
    },

    Clear(item) {
      if (item.TypeCrop != 2) this.FltCodeOrganic = NULL;
      return true;
    },

    clickView(val) {
      this.FltID = val.FltID;
      this.openDialogView = true;
    },
    clickViewPhone(val) {
      this.FltID = val.FltID;
      this.openDialogViewPhone = true;
    },
    savePhone(item) {
      item.FltID = this.FltID;
      item.UsrCreateID = this.$fun.getUserID();
      item.save();
    },
    savePlants(item) {
      item.FltID = this.FltID;
      item.UsrCreateID = this.$fun.getUserID();
      item.save();
    },
  },

  watch: {
    agriculturalFarmID() {
      this.Initialize();
    },
    showLotMapModal(val) {
      if (!val) {
        this.resetLotMapState();
        this.openingLotMap = false;
      }
    },
  },
  mounted() {},
  created() {
    this.filter = { FagID: this.agriculturalFarmID };
  },
};
</script>

<style scoped>
.map-container {
  width: 100%;
  height: calc(100vh - 180px);
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
}
</style>

<style>
.lot-polygon-tooltip {
  background-color: rgba(255, 255, 255, 0.95) !important;
  border: 2px solid #43a047 !important;
  border-radius: 6px !important;
  padding: 8px 12px !important;
  font-family: 'Roboto', Arial, sans-serif !important;
  font-size: 13px !important;
  line-height: 1.6 !important;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.25) !important;
  color: #333 !important;
}

.lot-polygon-tooltip::before {
  border-top-color: #43a047 !important;
}
</style>
